(function() {
  var TRANSLATIONS = {
    SELECT_SHAPE: "ODABERITE OBLIK",
    SELECT_BLADE: "ODABERITE OŠTRICU",
    SELECT_HANDLE: "ODABERITE DRŠKU",
    YOUR_SELECTION: "VAŠ IZBOR",
    REMOVE_SELECTION: "Ukloni izbor",
    CONFIRM_SELECTION: "Potvrdi izbor",
    HANDLING_TITLE: "Postavljanje drške i oštrice",
    HANDLING_DESCRIPTION: "Dodajte uslugu u košaricu kada naručite oštricu (nož bez drške) i dršku po mjeri te želite da vam postavimo dršku na oštricu.",
    PREVIEW_TITLE: "KONFIGURATOR - Sastavite svoj nož",
    BROWSER_NOT_SUPPORTED: "Vaš preglednik nije podržan. Za pristup konfiguratoru koristite Chrome, Edge, Firefox ili Safari.",
    NO_SHAPES: "Nema dostupnih oblika.",
    NO_BLADES: "Nema dostupnih oštrica za odabrani oblik i/ili veličinu drške. Pokušajte odabrati drugu dršku.",
    NO_HANDLES: "Nema dostupnih drški za odabrani oblik i/ili veličinu oštrice. Pokušajte odabrati drugu oštricu.",
    RESET_CONFIGURATOR: "Resetiraj konfigurator",
    SHAPE: "Oblik",
    BLADE: "Oštrica",
    HANDLE: "Drška",
    BUTTON_MORE: "Više",
    VIEW_MORE: "➕ Prikaži sve oblike noževa",
    VIEW_LESS: "➖ Prikaži manje",
    ADD_TO_CART: "Dodaj u košaricu",
    SOLD_OUT: "Nije dostupno",
    SAVE_BADGE: "Uštedi",
    SHARE: "Podjeli svoj personalizirani nož",
    COPIED_TO_CLIPBOARD: "Kopirano u međuspremnik!",
    BLADE_MODAL: {
      DESCRIPTION_TAB_NAME: "Opis",
      SPECIFICATIONS_TAB_NAME: "Specifikacije",
      BLADE_SHAPE: "Oblik oštrice",
      STEEL_TYPE: "Vrsta čelika",
      BLADE_CONSTRUCTION: "Konstrukcija oštrice",
      HARDNESS: "Tvrdoća (HRC skala)",
      OVERALL_LENGTH: "Ukupna duljina",
      BLADE_LENGTH: "Duljina oštrice",
      BLADE_HEIGHT: "Visina oštrice",
      SPINE_THICKNESS: "Debljina leđa",
      WEIGHT: "Težina",
      HANDLE_LENGTH: "Duljina drške",
      HANDLE_TYPE_WOOD: "Vrsta drške / drvo",
      KANJI_ON_THE_BLADE: "Kanji na oštrici",
      BLACKSMITH: "Kovač",
      LOCATION_OF_THE_SMITHY: "Lokacija kovačnice",
    }
  }

  window.TRANSLATIONS = TRANSLATIONS;
})();